// extracted by mini-css-extract-plugin
export default {"field":"LabelCreateStep_field__O0D61","fieldLabel":"LabelCreateStep_fieldLabel__paco+","controls":"LabelCreateStep_controls__jf7y2"};